module.exports = __webpack_public_path__ + "img/eliminar-duo.b7caec3d.svg";